export const BNGM_SECTION_KEY = 'BNGM_CAMPAIGN_PRODUCTS';
export const BNGM_SECTION_NAME = 'PRODUITS DE CAMPAGNE BNGM';
